var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoInvoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 25 25",
    style: {
      enableBackground: "new 0 0 25 25"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1,22.8h-13c-0.6,0-1-0.5-1-1V3.6c0-0.6,0.4-1,1-1h13c0.6,0,1-0.5,1-1c0-0.6-0.4-1-1-1h-13c-1.7,0-3,1.4-3,3v18.1 c0,1.7,1.3,3,3,3h13c0.6,0,1-0.5,1-1S16.7,22.8,16.1,22.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1,9.7h-5c-0.6,0-1,0.5-1,1c0,0.6,0.4,1,1,1h5c0.6,0,1-0.5,1-1C12.1,10.1,11.7,9.7,11.1,9.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1,5.7h-5c-0.6,0-1,0.5-1,1c0,0.6,0.4,1,1,1h5c0.6,0,1-0.5,1-1C12.1,6.1,11.7,5.7,11.1,5.7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1,13.7h-5c-0.6,0-1,0.5-1,1c0,0.6,0.4,1,1,1h5c0.6,0,1-0.5,1-1S11.7,13.7,11.1,13.7z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1,17.8h-5c-0.6,0-1,0.5-1,1c0,0.6,0.4,1,1,1h5c0.6,0,1-0.5,1-1C12.1,18.2,11.7,17.8,11.1,17.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1,15.2c-0.6,0-1,0.5-1,1c0,0.8-0.7,1.5-1.5,1.5h-1c-0.8,0-1.5-0.7-1.5-1.5v-1h2c0.5,0,1-0.5,1-1c0-0.6-0.5-1-1-1h-2v-1 h2c0.5,0,1-0.5,1-1c0-0.6-0.5-1-1-1h-2v-1c0-0.8,0.7-1.5,1.5-1.5h1c0.8,0,1.5,0.7,1.5,1.5c0,0.6,0.4,1,1,1c0.5,0,1-0.5,1-1 c0-1.9-1.6-3.5-3.5-3.5h-1c-1.9,0-3.5,1.6-3.5,3.5v1h-0.9c-0.5,0-1,0.5-1,1c0,0.6,0.5,1,1,1h0.9v1h-0.9c-0.5,0-1,0.5-1,1 c0,0.6,0.5,1,1,1h0.9v1c0,2,1.6,3.5,3.5,3.5h1c1.9,0,3.5-1.6,3.5-3.5C24.1,15.7,23.6,15.2,23.1,15.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoInvoice);
export default __webpack_public_path__ + "static/media/ico-invoice.8ff4995f0dddd4b814861d394ba4d7b2.svg";
export { ForwardRef as ReactComponent };